import {ExperienceMarker} from '../components/experience_marker';
import {downloadWithProgress} from "../../helpers/response";

export class ExperienceMarkersLoader {

    constructor(url, onlineApp) {
        this.url = url;
        this.onlineApp = onlineApp;

        this.experienceMarkerObjects = [];
        this.response = null;
        this.portionComplete = 0.0;
        this.complete = false;
    }

    async getExperienceMarkers() {
        this.experienceMarkerObjects = await this.loadExperienceMarkers()
        this.complete = true;
        return this.experienceMarkerObjects;
    }

    async loadExperienceMarkers() {
        this.response = await fetch(this.url);
        const experienceMarkerData = await this.downloadExperienceMarkerData();
        return createExperienceMarkers(experienceMarkerData, this.onlineApp);
    }

    async downloadExperienceMarkerData() {
        return JSON.parse(await downloadWithProgress(this.response, this.updateProgress.bind(this)));
    }

    updateProgress(portionComplete) {
        console.log(`[ExperienceMarkersLoader] Downloaded ${portionComplete * 100}%`);
        if (this.onlineApp) this.onlineApp.dispatchAction('updateBootProgress', portionComplete);
    }
}

function createExperienceMarkers(items, onlineApp) {
    return items.map((item) => {
        return new ExperienceMarker(item, onlineApp)
    });
}


